<footer class="pr-5 d-flex align-items-center justify-content-end">

    <mat-icon class="mr-1">mail</mat-icon> <a href="mailto:ep.eia@totalenergies.com">ep.eia@totalenergies.com</a> @Copyright 2021 MPS
</footer>